import { useEffect, useState } from 'react'

import { getOpportunityNotes } from '../api'
import { toast } from '@sales-center/components'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'

interface Props {
  opportunityId: number
  take: number
}

export const useGetOpportunityNotesOnMount = (props: Props) => {
  const dispatch = useAppDispatch()
  const { opportunityId, take } = props

  const [status, setStatus] = useState<'pending' | 'success' | 'fail'>(
    'pending',
  )

  useEffect(() => {
    let mounted = true

    const execute = async () => {
      try {
        const result = await dispatch(
          getOpportunityNotes({
            opportunityId,
            includeExternal: true,
            query: { take },
          }),
        )

        if (mounted) {
          if (getOpportunityNotes.fulfilled.match(result)) {
            setStatus('success')
          } else {
            setStatus('fail')
            toast.error('Error loading opportunity notes.')
          }
        }
      } catch {
        if (mounted) {
          setStatus('fail')
        }
      }
    }
    execute()

    return () => {
      mounted = false
    }
  }, [dispatch, opportunityId, take])

  return status
}
